import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const PaymentTerms = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("PaymentTerms", "terms/payment_body_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.PaymentTerms || { Main: {} };
  return (
    <div className="container py-5 text-start" style={{ lineHeight: "1.8em" }}>
      <h2 className="mb-4">{LANGUAGE.Main.Content1}</h2>

      <h4>{LANGUAGE.Main.Content2}</h4>
      <p>{LANGUAGE.Main.Content3}</p>
      <p>{LANGUAGE.Main.Content4}</p>

      <h4>{LANGUAGE.Main.Content5}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content6}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content7}</li>
            <li>{LANGUAGE.Main.Content8}</li>
          </ul>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content9}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content10}</li>
            <li>{LANGUAGE.Main.Content11}</li>
            <li>{LANGUAGE.Main.Content12}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content13}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content14}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content15}</li>
            <li>{LANGUAGE.Main.Content16}</li>
          </ul>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content17}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content18}</li>
            <li>{LANGUAGE.Main.Content19}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content20}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content21}</strong>
          <p>{LANGUAGE.Main.Content22}</p>
          <ul>
            <li>{LANGUAGE.Main.Content23}</li>
            <li>{LANGUAGE.Main.Content24}</li>
          </ul>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content25}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content26}</li>
            <li>{LANGUAGE.Main.Content27}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content28}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content29}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content30}</li>
            <li>{LANGUAGE.Main.Content31}</li>
          </ul>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content32}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content33}</li>
            <li>{LANGUAGE.Main.Content34}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content35}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content36}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content37}</li>
          </ul>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content38}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content39A}</li>
            <li>{LANGUAGE.Main.Content39}</li>
          </ul>
        </li>
      </ul>

      <hr className="my-4" />

      <h5>{LANGUAGE.Main.Content40}</h5>
      <p>
        {LANGUAGE.Main.Content41}
        <br />
        <strong>{LANGUAGE.Main.Content42}</strong> {LANGUAGE.Main.Content43}
        <br />
        <strong>{LANGUAGE.Main.Content44}</strong>{" "}
        <a href={`mailto:${LANGUAGE?.Main?.Content45}`}>
          {LANGUAGE.Main.Content45}
        </a>
        <br />
        <strong>{LANGUAGE.Main.Content46}</strong>{" "}
        <a
          href={LANGUAGE.Main.Content47}
          target="_blank"
          rel="noopener noreferrer"
        >
          {LANGUAGE.Main.Content47}
        </a>
      </p>
    </div>
  );
};

export default PaymentTerms;
